import React, {useMemo} from "react";
import {twJoin} from "tailwind-merge";
import {IconType} from "peggirkit";
import {CheckCircleIcon, CheckIcon} from "@heroicons/react/16/solid";

type Props = {
    selected: boolean,
    canSelectMultiple: boolean,
};

const RadioCheckIndicator = ({canSelectMultiple, selected}: Props) => {
    const Icon: IconType = useMemo(
        () => canSelectMultiple ? CheckIcon : CheckCircleIcon,
        [canSelectMultiple]);

    return (
        <div
            role={"presentation"}
            className={"group-data-[disabled]/item:invisible flex group-data-[disabled]/item:opacity-40 size-[20px] sm:size-[30px] p-0.5 sm:p-1.5 grow-0 shrink-0"}
        >
            <div
                className={twJoin(
                    "w-full h-full border border-gray-300 bg-white group-data-[selected]/item:bg-blue-600 group-data-[selected]/item:border-blue-600",
                    canSelectMultiple
                        ? "rounded p-0.5"
                        : "rounded-full p-1",
                )}
            >
                {selected && (
                    <Icon className={"w-full h-auto fill-white"}/>
                )}
            </div>
        </div>
    );
};

export default RadioCheckIndicator;